export var CoverRequestsGroupingCriteria;
(function (CoverRequestsGroupingCriteria) {
    CoverRequestsGroupingCriteria["ByInsuranceCompany"] = "by-insurance-company";
})(CoverRequestsGroupingCriteria || (CoverRequestsGroupingCriteria = {}));
